<template>
  <!-- 分拣漏扫监控 -->
  <div class="Box">
    <el-card>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="一级分拣（Triagem Nível 1）" name="first">
        <levelOne ref="levelOne" @parentMethod="openMiss" />
      </el-tab-pane>
      <el-tab-pane label="二三级分拣（Triagem Níveis 2-3）" name="second">
        <levelTwoThree ref="levelTwoThree" @parentMethod="openMiss" />
      </el-tab-pane>
    </el-tabs>
    </el-card>
    <!-- 漏扫明细 ———— 弹框 -->
    <el-dialog
      title="漏扫明细（Detalhes Perdidos）"
      :visible.sync="missVisible"
      width="80%"
      :before-close="missClose"
    >
      <div style="margin-bottom: 10px">
        <el-button type="primary" @click="missExportAll">导出（Exportar）</el-button>
      </div>
      <el-table
        :data="missTableData"
        style="width: 100%"
        size="small" max-height="600" border
        :header-cell-style="{background: '#f2f2f1', color: '#000', 'font-size': '15px'}"
      >
        <el-table-column label="序号（No.）" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ (missForm.pageNumber - 1) * missForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="waybillNumber" label="运单号（Número de waybill）" align="center"
          width="170"
        />
        <!--运单状态-->
        <el-table-column prop="waybillStatusName" label="运单状态（Status do Pacote）" align="center" />
        <!--漏扫操作-->
        <el-table-column
          prop="missOperationTypeName" label="漏扫操作（Ops Perd.Digitalização）" align="center"
          width="170"
        />
        <!--漏扫网点-->
        <el-table-column prop="missSite" label="漏扫网点（Centro de Digitalização Omitida）" align="center" />
        <!--网点所属州-->
        <el-table-column
          prop="state" label="网点所属州（Estado de origem）" align="center"
          width="170"
        />
        <!--所属大区-->
        <el-table-column prop="regionName" label="所属大区（Pertence à região）" align="center" />
      </el-table>
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="missForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size.sync="missForm.pageSize"
          :total="missTotal"
          background
          style="margin: 10px 0"
          @current-change="missPage"
          @size-change="missSearch"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sortingMissScanDetailPage, sortingMissScanDetailExport } from '@/api/orderApi';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  name: 'SortingMissedScanMonitor',
  components: {
    levelOne: () => import('./component/levelOne.vue'),
    levelTwoThree: () => import('./component/levelTwoThree.vue')
  },
  data() {
    return {
      activeName: 'first',
      missVisible: false,
      missTableData: [],
      missTotal: 0,
      missForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {}
      }
    };
  },
  methods: {
    handleClick() {
      if (this.activeName === 'first') {
        this.$refs.levelOne.toSearch();
      } else {
        this.$refs.levelTwoThree.toSearch();
      }
    },
    missClose() {
      this.missVisible = false;
    },
    openMiss(startDate, endDate, dataType, regionIds, states) {
      // dataType 数据类型: 3-一级卸车漏扫数, 5-一级到件漏扫数, 7-一级集包漏扫数, 9-一级装车漏扫数, 15-二级卸车漏扫数, 17-二级集包漏扫数, 18-二级装车漏扫数, 24-三级卸车数, 26-三级装车漏扫数
      this.missForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startDate,
          endDate,
          dataType,
          regionIds,
          states
        }
      };
      sortingMissScanDetailPage(this.missForm).then(res => {
        if (res.code === 200) {
          this.missTableData = res.data.records;
          this.missTotal = res.data.total;
          this.missVisible = true;
        }
      });
    },
    missPage() {
      sortingMissScanDetailPage(this.missForm).then(res => {
        if (res.code === 200) {
          this.missTableData = res.data.records;
          this.missTotal = res.data.total;
        }
      });
    },
    missSearch() {
      this.missForm.pageNumber = 1;
      this.missPage();
    },
    missExportAll() {
      if (this.missTableData.length <= 0) {
        this.$message.warning('列表暂无数据，无法导出（A lista não tem dados e não pode ser exportada）');
      } else {
        sortingMissScanDetailExport(this.missForm.params).then(res => {
          if (res.code === 200) {
            goRWExportList(this).then((res) => {
              if (res) {
                this.missVisible = false;
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__wrapper .el-dialog {
  margin-top: 0 !important;
}
</style>
